import { IDeliveryChargeAreaMutations, } from '@/vuex-store/delivery-charge-area-control/types';
const mutations = {
    [IDeliveryChargeAreaMutations.SET_SEARCH_VALUE](state, { field, value }) {
        state.searchValue[field] = value;
    },
    [IDeliveryChargeAreaMutations.SET_EUP_MYEON_DONG_BOUNDARY_CURRENT_INFO](state, { isDelete, item }) {
        if (isDelete) {
            state.eupMyeonDongBoundaryInfo.currentInfo = {};
            return;
        }
        state.eupMyeonDongBoundaryInfo.currentInfo[item.areaId] = item;
    },
    [IDeliveryChargeAreaMutations.SET_EUP_MYEON_DONG_BOUNDARY_VISIBLE_LIST](state, { isVisible, areaId }) {
        const prev = state.eupMyeonDongBoundaryInfo.visibleList[areaId];
        if (!prev) {
            const { areaId: currentAreaId, areaName } = state.eupMyeonDongBoundaryInfo.currentInfo[areaId];
            state.eupMyeonDongBoundaryInfo.visibleList[areaId] = {
                areaId: currentAreaId,
                areaName,
                isVisible,
            };
            return;
        }
        state.eupMyeonDongBoundaryInfo.visibleList[areaId] = {
            ...prev,
            isVisible,
        };
    },
    [IDeliveryChargeAreaMutations.SET_REGISTERED_AREA_LIST](state, list) {
        state.registeredAreaList = list;
    },
    [IDeliveryChargeAreaMutations.SET_CHECKED_AREA_LIST](state, { isDelete, data }) {
        if (isDelete) {
            delete state.checkedAreaList[data.areaId];
            return;
        }
        state.checkedAreaList[data.areaId] = data;
    },
    [IDeliveryChargeAreaMutations.SET_SELECTED_AREA](state, { isBoundaryList, areaId: selectedId }) {
        if (isBoundaryList) {
            const { areaId, areaName } = state.eupMyeonDongBoundaryInfo.visibleList[selectedId];
            state.selectedArea = {
                areaId,
                areaName,
            };
            return;
        }
        // 전체 목록에서 찾도록 변경
        // const { areaId, areaName } = state.checkedAreaList[selectedId];
        const { areaId, areaName } = state.registeredAreaList
            .find((area) => area.areaId === selectedId);
        state.selectedArea = {
            areaId: String(areaId),
            areaName,
        };
    },
    [IDeliveryChargeAreaMutations.SET_IS_CREATE_AREA_MODE](state, isCreateAreaMode) {
        state.isCreateAreaMode = isCreateAreaMode;
    },
    [IDeliveryChargeAreaMutations.SET_CURRENT_POLYGON_COORDINATE_LIST](state, list) {
        state.currentPolygon.coordinateList = list;
    },
    [IDeliveryChargeAreaMutations.SET_CURRENT_POLYGON_NEED_RESET_LIST](state, list) {
        state.currentPolygon.needResetList = list;
    },
    [IDeliveryChargeAreaMutations.RESET_STORE](state) {
        state.searchValue = {
            areaName: '',
            dongName: '',
        };
        state.eupMyeonDongBoundaryInfo = {
            visibleList: {},
            currentInfo: {},
        };
        state.registeredAreaList = [];
        state.checkedAreaList2 = [];
        state.checkedAreaList = {};
        state.selectedArea = {
            areaId: '',
            areaName: '',
        };
        state.isCreateAreaMode = false;
        state.currentPolygon = {
            coordinateList: [],
            needResetList: [],
        };
    },
    SET_CHECKED_AREA_LIST2(state, value) {
        state.checkedAreaList2 = value;
    },
};
export default mutations;
